"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Envelope = void 0;
var tracker_1 = require("./tracker");
var uuid_1 = require("uuid");
var Envelope = /** @class */ (function () {
    function Envelope(event, global) {
        this.event = event;
        this.eid = (0, uuid_1.v4)();
        this.ts_ms = Date.now();
        this.created_at = Date.now();
        this._tracker = new tracker_1.Tracker();
        this._globalBPO = global;
    }
    Object.defineProperty(Envelope.prototype, "tracker", {
        get: function () {
            return this._tracker;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Envelope.prototype, "global", {
        get: function () {
            return this._globalBPO;
        },
        enumerable: false,
        configurable: true
    });
    Envelope.getAttributeTypeMap = function () {
        return Envelope.attributeTypeMap;
    };
    Envelope.attributeTypeMap = [
        {
            name: 'eid',
            baseName: 'eid',
            type: 'string',
        },
        {
            name: 'ts_ms',
            baseName: 'ts_ms',
            type: 'number',
        },
        {
            name: 'created_at',
            baseName: 'created_at',
            type: 'number',
        },
        {
            name: 'event',
            baseName: 'event',
            type: 'Event',
        },
        {
            name: 'global',
            baseName: 'global',
            type: 'Event',
        },
        {
            name: 'tracker',
            baseName: 'tracker',
            type: 'Tracker',
        },
    ];
    return Envelope;
}());
exports.Envelope = Envelope;
//# sourceMappingURL=envelope.js.map